import { h, onMounted, ref } from 'vue';

import { frontendURL } from '../../../helper/URLHelper';

export const AgendaVisitDetailReferenceAdapter = {
  name: 'AgendaVisitDetailReferenceAdapter',
  setup() {
    const mainElement = ref(null);

    onMounted(() => {
      mainElement.value.focus();
    });

    return () =>
      h('main', { ref: mainElement, tabindex: '-1' }, [
        h('h1', 'Detalhes da visita'),
      ]);
  },
};

export const agendaVisitDetailRoute = {
  path: frontendURL(
    'accounts/:accountId/agenda/detalhes/data/:dateEpoch/imovel/:houseId'
  ),
  component: AgendaVisitDetailReferenceAdapter,
};

export default agendaVisitDetailRoute;
